import { __awaiter } from "tslib";
import { TeleInterconsultService } from "@/servicesTs/models/teleopi/teleInterconsult";
const moduleTableTICReception = {
    namespaced: true,
    state: {
        teleInterconsults: [],
        dataFilter: {
            step: "",
            node_id: 0,
            state: "",
        },
        showLoader: false,
    },
    getters: {
        getShowLoader(state) {
            return state.showLoader;
        },
        getTICReception(state) {
            return state.teleInterconsults;
        },
    },
    mutations: {
        setLoader(state, payLoad) {
            state.showLoader = payLoad;
        },
        setDatafilter(state, payLoad) {
            state.dataFilter = payLoad;
        },
        setTICReception(state, teleInterconsults) {
            state.teleInterconsults = teleInterconsults;
        },
    },
    actions: {
        getTICReception({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoader", true);
                let response = yield TeleInterconsultService.getTicByStateStepAndDestinationNode(state.dataFilter.step, state.dataFilter.node_id, state.dataFilter.state);
                commit("setTICReception", response);
                commit("setLoader", false);
            });
        },
    },
};
export default moduleTableTICReception;
